import { EarHearingLoopIcon } from './EarHearingLoopIcon';

/**
 * author: Michael Irigoyen
 * id E95219F9-AA02-4031-940F-D76757183F96
 * name ear-hearing-loop
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ear-hearing-loop.svg
 * tags
 * - Medical / Hospital 
 */
export const TelecoilIcon = EarHearingLoopIcon;
export default TelecoilIcon